import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import verified from 'images/wbaccount/verification_sent.png';
import PageTemplate from 'components/ChangePassword/PageTemplate';
import styles from 'components/ChangePassword/ChangePassword.module.scss';

export type ForgotPasswordMailSentProps = {
  email: string;
};

const ForgotPasswordMailSent = ({ email }: ForgotPasswordMailSentProps) => {
  const { t } = useTranslation();
  return (
    <PageTemplate>
      <h1 className={styles.title}>{t('MPL_FORGOT_PASSWORD_EMAIL_SENT_TITLE')}</h1>
      <p className={styles.text}>
        <Trans
          i18nKey="MPL_FORGOT_PW_RESET_EMAIL_SENT"
          values={{
            email,
          }}
          components={{ b: <b /> }}
        />
      </p>
      <div id="successForgotPasswordEmailSent" className={styles.imageContainer}>
        <img src={verified} className={styles.webAccountImage} alt="forgot password email sent" />
      </div>
    </PageTemplate>
  );
};

export default ForgotPasswordMailSent;
